import { useState,useEffect } from 'react';
import { Header, Singolo, Tabs, Timer } from "../../Components";
import { GrClose, GrRefresh } from 'react-icons/gr';
import { AiOutlineCheck } from 'react-icons/ai';
import { List } from '../../utils/constants';
import ProgressBar from '../../Components/ProgressBar/ProgressBar';

const Coppia_Gamberone_1 = (props) => {
    const { setMultipleDifficolta, setAvvia, setGiocatori, setDificolta, setChampion, setLoss } = props;
    const [isVisible, setIsVisible] = useState(true);
    const [isClicked, setIsClicked] = useState(false);
    const [isClose, setIsClose] = useState(false);

    const [showText, setShowText] = useState(false);
    const [progressKey, setProgressKey] = useState(0);
    const [showCheckIcon, setShowCheckIcon] = useState(false);
    const [currentIndex, setCurrentIndex] = useState(0);
    const [timeUp, setTimeUp] = useState(false);
    const [restartTimer, setRestartTimer] = useState(false);
    const [item, setItem] = useState(() => {
        const randomIndex = Math.floor(Math.random() * List.length);
        return List[randomIndex];
    });
    useEffect(() => {
        const handleVisibilityChange = () => {
            setIsVisible(!document.hidden);
        };

        document.addEventListener('visibilitychange', handleVisibilityChange);

        return () => {
            document.removeEventListener('visibilitychange', handleVisibilityChange);
        };
    }, []);
    const handleNextClick = () => {
        // setShowText(false);
        const nextIndex = (currentIndex + 1) % item.length;
        setCurrentIndex(nextIndex);
        setTimeUp(false);
        setProgressKey((prevKey) => prevKey + 1); 
        setIsClicked(true);
        setIsClose(false)

        if (nextIndex === 0) {
            localStorage.removeItem('selectedTime');
            localStorage.removeItem('selectedSecond');
            setChampion(true)
            setMultipleDifficolta(false)
            setAvvia(false)


        }
        setTimeout(() => {
            setIsClicked(false);
        }, 500); 
    };

    const cancelClick = () => {
        setCurrentIndex(0);
        setShowCheckIcon(false);
        // setShowText(false);
        setTimeUp(false);
        setProgressKey((prevKey) => prevKey + 1); // Update progressKey
        setIsClicked(false);
        setIsClose(true)


    };

    const handleRefreshClick = () => {
        // setCurrentIndex(0);
        // setShowCheckIcon(false);
        // setGiocatori(false)
        // setMultipleDifficolta(false)
        setAvvia(false)
        localStorage.removeItem('selectedTime');
        localStorage.removeItem('selectedSecond');
        // setShowText(false);
        setTimeUp(false);
        setProgressKey((prevKey) => prevKey + 1); // Update progressKey
        setRestartTimer((prevRestartTimer) => !prevRestartTimer); // Toggle restartTimer state to trigger restart in Timer component

    };

    const Back = () => {
        setMultipleDifficolta(false);
        setAvvia(false)
        localStorage.removeItem('selectedTime');
        localStorage.removeItem('selectedSecond');
        
    };
    console.log(item);

    return (
        <>
            <div>
                <div>
                    <Header icon1={<GrClose className='header_icon' onClick={Back} />} icon2={<GrRefresh className='header_icon' onClick={handleRefreshClick} />} />
                </div>
                <div className="main_div2">
                    <div className="singolo_div">
                        <div>
                            <div className="tabs_main_div">
                                {item.map((_, index) => (
                                    <div key={index} className={`tabs_inner_div ${currentIndex >= index ? 'tabs_div' : ''}`} />
                                ))}
                            </div>
                        </div>

                        <div className={`animationContainer animate__animated ${isClicked ? 'animate__slideInRight faster-animation' : ''} ${isClose ? 'animate__slideInLeft faster-animation' : ''}`}>
                            <div className="singolo_inner_div1">{currentIndex + 1} </div>
                            <div className="singolo_inner_div2">{item[currentIndex].domanda}</div>
                            <div className={'singolo_inner_div3'}>
                                {item[currentIndex].risposta}
                            </div>

                            <div className={!timeUp ? "singolo_inner_div4" : "singolo_inner_div5 animate__slideInLeft more-faster-animation"}>
                                <div className="singolo_icon_div">
                                    <GrClose className="singolo_icon" onClick={cancelClick} />
                                </div>
                                {!timeUp && (
                                    <div className="singolo_icon_main_div" onClick={handleNextClick}>
                                        <ProgressBar key={progressKey} setTimeUp={setTimeUp} 
                                            isVisible={isVisible} 

                                        />
                                        <div className="singolo_icon_div2">
                                            <AiOutlineCheck className="singolo_icon" onClick={() => setIsClicked(true)} />

                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                        <div className='timer_main_div'>
                            <Timer key={restartTimer ? 'restart' : 'no-restart'}  restart={restartTimer} 
                                setGiocatori={setGiocatori}
                                setDificolta={setDificolta}
                                setMultipleDifficolta={setMultipleDifficolta}
                                setAvvia={setAvvia}
                                setLoss={setLoss}


                            />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Coppia_Gamberone_1;
